import React, { useState, useCallback, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import Header from '../../components/Header'
import Button from '../../components/Button'
import ModalBox from '../../components/Modal'

import { Content, BtnVoltar } from './styles'
import Container from '../../components/Container'

const HasBeneficiaries: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [txtModal] = useState('')

  const history = useHistory()

  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false)
  }, [])

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  }, [])

  return (
    <>
      <Header />
      <Container>
        <Content>
          <p>Você deseja cadastrar seus beneficiários?</p>
          <Button
            type="button"
            onClick={() => history.push('/beneficiary')}
            width="large"
            fontSize="normal"
            color="orange"
          >
            Sim
          </Button>
          <br />
          <Button
            type="button"
            onClick={() => history.push('/resume')}
            width="large"
            fontSize="small"
          >
            Agora não, vou cadastrar depois
          </Button>
        </Content>
        <BtnVoltar type="button" onClick={() => history.push('/pep')}>
          &lt; Anterior
        </BtnVoltar>
        <ModalBox isOpen={isModalOpen} onRequestClose={handleCloseModal}>
          {txtModal}
        </ModalBox>
      </Container>
    </>
  )
}

export default HasBeneficiaries
